import React, { useState, useRef, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'
import { fetchProductPackage } from '../products/productActions'
import { displayNotification } from '../../actions/notificationsActions'

const Iframe = ({ productPackage }) => {
  if (!productPackage) {
    return null
  }

  const src = `${process.env.REACT_APP_BLINKER_API_URL}/packages/${productPackage.customerToken}/confirm`

  const style = {
    width: '100%',

    // 123px = 76px top bar + 42px breadcrumb + 5px possible scrollbar
    height: 'calc(100vh - 123px)',
  }

  return <iframe src={src} style={style} />
}

const PaymentForm = () => {
  const useQuery = () => new URLSearchParams(useLocation().search)
  const query = useQuery()
  const packageId = query.get('packageId')

  const dispatch = useDispatch()
  const history = useHistory()

  const [state, setState] = useState({
    productPackage: null,
    levels: [
      { label: 'Index', path: '/' },
      { label: 'People', path: '/users' },
    ],
  })

  // track reference to user for redirect
  const userRef = useRef()

  const loadProductPackage = async () => {
    const productPackage = await dispatch(fetchProductPackage(packageId))

    // redirect to sign documents if already paid
    if (productPackage.paidAt) {
      history.replace(`/refiApp/agreement?packageId=${packageId}`)
      return
    }

    const { user } = productPackage
    const { firstName, lastName, id } = user

    userRef.current = user

    setState({
      productPackage,
      levels: state.levels.concat([
        { label: `${firstName} ${lastName}`, path: `/users/${id}` },
        { label: 'Payment' },
      ]),
    })
  }

  useEffect(() => {
    loadProductPackage()

    // listen for message from iframe page
    const onMessage = (event) => {
      switch (event.data.type) {
        case 'PAYMENT_SUCCESS':
          // Redirect to product and payment agreements
          history.replace(`/refiApp/agreement?packageId=${packageId}`)
          dispatch(displayNotification('Payment complete'))
          break
        case 'PAYMENT_CANCELED':
          // Return to user profile
          history.replace(`/users/${userRef.current.id}`)
      }
    }

    window.addEventListener('message', onMessage)

    return () => {
      window.removeEventListener('message', onMessage)
    }
  }, [])

  const levels = [].concat(state.levels)
  if (!state.productPackage) {
    levels.push({ label: 'Loading...' })
  }

  const onStubClick = async () => {
    const transactionId = `fake-${Date.now()}`
    const data = {
      sourceReferenceId: state.productPackage.customerToken,
    }

    await fetch(
      `${
        process.env.REACT_APP_BLINKER_API_URL
      }/api/v3/products/payment?result=success&transaction_id=${transactionId}&data=${btoa(
        JSON.stringify(data)
      )}`
    )

    history.replace(`/refiApp/agreement?packageId=${packageId}`)
    dispatch(displayNotification('Payment complete'))
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        <Breadcrumb levels={levels} />
        <a
          style={{ position: 'absolute', top: 0, right: 0, margin: '1rem' }}
          href="#"
          onClick={onStubClick}
        >
          mark as paid
        </a>
      </div>
      <LoadingSection isLoading={!state.productPackage}>
        <Iframe productPackage={state.productPackage} />
      </LoadingSection>
    </>
  )
}

export default PaymentForm
